export const findCourse = async ({BeURL,departmentId}) => {
    try {
        const res = await fetch(`${BeURL}/find-Course?departmentId=${departmentId}`, {
            method: "GET",
            credentials: "include",
        });

        const data = await res.json();

        return data;
    } catch (err) {
        console.log("Error in find courses", err);
        return { success: false, message: err.message };
    }
}
